import Box from '@mui/material/Box';
import colors from 'styles/colors';

const Paper = ({ children, sx, ...rest }) => (
  <Box
    sx={{
      background: colors.background.paper_5p,
      border: `1px solid ${colors.border.border_5p}`,
      borderRadius: '24px',
      padding: '24px',
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);

export default Paper;
